import { FILTERS_SET_ORDER_TYPE_TYPE } from '../../constants/actionTypes';
import { TReduxActions } from '../../types/redux';
import { EOrderField } from '../../repositories/favorites/v1/web-get-user-favorites';

const defaultDealType = EOrderField.Added;

export function orderFieldReducer(state: EOrderField = defaultDealType, action: TReduxActions) {
  switch (action.type) {
    case FILTERS_SET_ORDER_TYPE_TYPE:
      return action.orderField;
  }

  return state;
}
